<div class="attribute-list">
    <div class="add-new-button">
        <app-button
            [buttonType]="'secondary'"
            [leftIcon]="'plus'"
            [label]="'attributeList.button.new' | translate"
            (click)="openAddAttributeDialog()"
        ></app-button>
    </div>
    <table mat-table [dataSource]="currentAttributeItems" class="mat-elevation-z0" matSort (matSortChange)="sortChange($event)">

        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"attributeList.column.id" | translate}}</th>
            <td mat-cell *matCellDef="let attribute"> {{attribute.id}} </td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"attributeList.column.name" | translate}}</th>
            <td mat-cell *matCellDef="let attribute"> {{attribute.name}} </td>
        </ng-container>

        <ng-container matColumnDef="attributeType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"attributeList.column.attributeType" | translate}}</th>
            <td mat-cell *matCellDef="let attribute"> {{attribute.attributeType}} </td>
        </ng-container>

        <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"attributeList.column.title" | translate}}</th>
            <td mat-cell *matCellDef="let attribute"> {{attribute.title}} </td>
        </ng-container>

        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>{{"attributeList.column.action" | translate}}</th>
            <td mat-cell *matCellDef="let attribute">
                <div class="container">
                    <button mat-button
                            class="table-button"
                            [matTooltip]="'attributeList.tooltips.editJson' | translate"
                            (click)="openEditAttributeJsonDialog(attribute)">
                        <mat-icon class="icon">data_object</mat-icon>
                    </button>
                    <button mat-button
                            class="table-button"
                            [matTooltip]="'attributeList.tooltips.editForm' | translate"
                            (click)="openEditAttributeFormDialog(attribute)">
                        <mat-icon class="icon">edit</mat-icon>
                    </button>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

    <div>
        <p>{{ 'attributeList.resultCount' | translate : { count: count } }}</p>
        <button [disabled]="currentPage <= 0" (click)="paginate(currentPage - 1)">Vorige</button>
        <button [disabled]="!hasNextPage" (click)="paginate(currentPage + 1)">Volgende</button>
        <select [ngModel]="pageSize" (ngModelChange)="setPageSize($event)">
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="25">25</option>
        </select>
    </div>
</div>

